export default __webpack_public_path__ + "static/assignee-dont-0ec3ee34e628e05a2cb6ccf3fb4c829f.png";